<script setup lang="ts">
import { EColors } from '@/types/constants/ColorValues'
import { EPosition } from '@/types/constants/PositionValues'
import { ESize } from '@/types/constants/SizeValues'

type Props = {
    label?: string
    type?: EColors
    position?: EPosition
    autoPosition?: boolean
    size?: ESize
    disableTooltip?: boolean
}
withDefaults(defineProps<Props>(), {
    position: EPosition.TOP,
    type: EColors.PRIMARY,
    size: ESize.MEDIUM
})
</script>

<template>
    <slot v-if="disableTooltip" v-bind="$attrs" />
    <b-tooltip
        v-else
        :label="label"
        :position="autoPosition ? undefined : `is-${position}`"
        :type="`is-${type}`"
        :size="`is-${size}`"
        class="tooltip-class"
        v-bind="$attrs">
        <slot />
        <template #content><slot name="content" /></template>
    </b-tooltip>
</template>
